import React, { FunctionComponent } from "react";
import styles from "../HeroPanel.module.css";
import classNames from "classnames";
import { motion, AnimatePresence } from "framer-motion";
import classnames from "classnames";
import he from "he";

type TContentOverlayBlockProps = {
  mobile?: boolean;
  blur?: boolean;
  activePanel?: boolean;
  p: any;
  key: string;
};

 const _ContentOverlayBlock: FunctionComponent<
  TContentOverlayBlockProps
> = ({ activePanel, p, blur, mobile }) => {

  const anchorTarget = p.FeaturedSubPage?.Url || p.Url;
  const TagName = p.ActiveTag?.TagName;
  const Title = p.FeaturedSubPage?.Title || p.Title;

  const c = (
    <motion.div
      className={"textWrapper"}
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
        transition: {
          delay: 0.4,
          bounce: 0.1,
        },
      }}
    >
      { TagName && <motion.h3 className={styles.tagName}>{he.decode(TagName)}</motion.h3> }
      <AnimatePresence>
        <motion.h2
          onClick={() => (window.location.href = anchorTarget)}
          dangerouslySetInnerHTML={{ __html: Title }}
        />
      </AnimatePresence>
      <a href={anchorTarget}>
        LEARN MORE
        <svg
          style={{ marginLeft: "5px" }}
          width="6"
          height="9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5.75 5.25 4.5 1.5 8.25"
            stroke="#84BD00"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      </a>
    </motion.div>
  );

  return (
    <>
      <motion.div
        className={classnames(styles.panelOverlay, {
          active: activePanel === p.Title,
        })}
      >
        {activePanel && c}
        {mobile && c}
      </motion.div>
    </>
  );
};

export const ContentOverlayBlock = React.memo(_ContentOverlayBlock);
